var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.257,10.2V6.575h2.927V4.75a4.775,4.775,0,0,1,1.282-3.363A4.078,4.078,0,0,1,20.572,0h2.907V3.629H20.572a.64.64,0,0,0-.512.313,1.273,1.273,0,0,0-.228.77V6.574h3.647V10.2H19.831V19H16.183V10.2Z","transform":"translate(-13.257)","fill":"#37383c"}));
}

Facebook.defaultProps = {"width":"10.222","height":"19","viewBox":"0 0 10.222 19"};

module.exports = Facebook;

Facebook.default = Facebook;
